import { Injectable } from '@angular/core';
import { IConfiguration } from '@gishub/domain';

declare global {
  interface Window {
    __ENV: {
      production: boolean;
      apiUrl: string;
      proxyUrl: string;
      geoserverUrl: string;
      arcgisPrintServiceUrl: string;
      appName: string;
      version: string;
    };
  }
}

@Injectable({ providedIn: 'root' })
export class Configuration implements IConfiguration {
  private get env() {
    // ❌ SIN fallback: Si window.__ENV no existe, lanzamos error explícito
    if (!window.__ENV) {
      throw new Error(
        '⚠️ Configuration: window.__ENV no está definido. ' +
        '¿Olvidaste cargar assets/env.js en index.html o generar el archivo en Docker?'
      );
    }
    return window.__ENV;
  }

  get isProduction(): boolean {
    return this.env.production === true;
  }

  get apiUrl(): string {
    return this.env.apiUrl;
  }
  get proxyUrl(): string {
    return this.env.proxyUrl;
  }


  get appName(): string {
    return this.env.appName;
  }

  get version(): string {
    return this.env.version;
  }
}